import Vue from 'vue'
import Util from '../util'

Vue.filter('StatusFile', function (status) {
  const statusFile = {
    stock: 'En stock',
    req: 'Solicitado',
    trans: 'En transporte',
    out: 'En cliente',
    pickup: 'Solicitud de recojo',
    transpickup: 'En proceso de recojo',
    low_file: 'Solicitud de baja',
    final_departure: 'Salida Definitiva'
  }
  return statusFile[status] || 'eliminado';
})

Vue.filter('StatusBox', function (status) {
  const statusBox = {
    stock: 'En stock',
    req: 'Solicitado',
    trans: 'En transporte',
    out: 'En cliente',
    withoutstock: 'Sin stock',
    pickup: 'Solicitud de recojo',
    transpickup: 'En proceso de recojo',
    low_box: 'Solicitud de baja',
    final_departure: 'Salida Definitiva'
  }
  return statusBox[status];
})

Vue.filter('StatusOrder', function (status) {
  if (status === 'pen') return 'Pendiente'
  if (status === 'apr') return 'Aprobado'
  if (status === 'ent') return 'Entregado'
  if (status === 'recog') return 'Recogido'
  if (status === 'can') return 'Cancelado'
  return 'Error'
})

Vue.filter('NamePriority', function (priority) {
  if (priority === 'normal') return 'Normal'
  if (priority === 'urgent') return 'Urgente'
  return 'Sin prioridad'
})

Vue.filter('StatusDigitalization', function (status) {
  if (status === 'req') return 'Pendiente'
  if (status === 'comp') return 'Aprobado'
  if (status === 'canc') return 'Cancelado'
  if (status === 'dis') return 'Desaprobado'
  if (status === 'del') return 'Entregado'
  return 'Error'
})

Vue.filter('StatusconsulFiles', function (status) {
  if (status === 'req') return 'Pendiente'
  if (status === 'comp') return 'Aprobado'
  if (status === 'canc') return 'Cancelado'
  if (status === 'dis') return 'Desaprobado'
  if (status === 'fina') return 'Finalizado'
  return 'Error'
})

Vue.filter("StatusOrderConvert", function (status) {
  if (status === 'pen') return 'Pendiente'
  if (status === 'apr') return 'Aprobado'
  if (status === 'env') return 'Enviado'
  if (status === 'envobs') return 'Enviado con observaciones'
  if (status === 'ent') return 'Entregado'
  if (status === 'entobs') return 'Entregado  con observaciones'
  if (status === 'recog') return 'Recogido'
  if (status === 'can') return 'Cancelado'
  if (status === 'canc') return 'Cancelado'
  if (status === 'recep') return 'Recepcionado por cliente'
  if (status === 'req') return 'Pendiente'
  return 'Error'
})

Vue.filter("StatusPickupConvert", function (status) {
  if (status === 'pen') return 'Pendiente'
  if (status === 'apr') return 'Aprobado'
  if (status === 'recog') return 'Recogido'
  if (status === 'can') return 'Cancelado'
  return 'Error'
})

Vue.filter('NombreUsuario', function (id) {
  const user = Util.getUsers().find(user => user.id === id);
  if (user)
    return user.person.firstName + ' ' + user.person.lastName
  else
    return id

})

Vue.filter("FileSize", function (tam) {
  const units = [
    'bytes',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB'
  ];

  if (isNaN(parseFloat(tam)) || !isFinite(tam)) {
    return '?';
  }

  let unit = 0;

  while (tam >= 1024) {
    tam /= 1024;
    unit++;
  }

  return parseFloat(tam).toFixed(2) + ' ' + units[unit];

})

Vue.filter('TypeImport', function (type) {
  if (type === 'FILE') return 'Files'
  if (type === 'MEDIOS') return 'Medios'
  if (type === 'MICROFORMA') return 'Microformas'
  if (type === 'PLANOS') return 'Planos'
  if (type === 'MUESTRAS') return 'Muestras'
  if (type === 'BOX') return 'Cajas'
  if (type === 'BOX_MEDIOS') return 'Caja Medios'
  if (type === 'BOX_LOCKER') return 'Casillero'
  if (type === 'BOX_PLANOS') return 'Caja Planos'
  if (type === 'BOX_MUESTRAS') return 'Caja Muestras'
  return 'Sin tipo'
})

Vue.filter('StatusImport', function (type) {
  if (type === 'upinit') return 'Carga Inicial'
  if (type === 'proc') return 'Procesado'
  return 'Sin carga de data'
})

Vue.filter('StatusFirstPickup', function (type) {
  if (type === true) return 'Recogido'
  return 'Pendiente'
})



// WEBPACK FOOTER //
// ./src/filters/index.js